import { __awaiter } from "tslib";
import { useEffect, useState } from 'react';
import devConfig from '../config.development.json';
import { fillInObject } from './util/fillInObject';
const origin = typeof window !== 'undefined' ? window.location.origin : '';
const USER_PORTAL_CONFIG_URL = `${origin}/userportal.config.json`;
const CONFIG_URL = `${origin}/config.json`;
const CONFIG_OVERRIDE_URL = `${origin}/config.overrides.json`;
const CONFIG = 'config';
const CONFIG_REFETCH_INTERVAL = 5 * 60 * 1000;
const fetchJson = (url) => __awaiter(void 0, void 0, void 0, function* () {
    const response = yield fetch(url, {
        headers: {
            Accept: 'application/json',
            Pragma: 'no-cache',
            'Cache-Control': 'no-cache',
        },
    });
    let result = null;
    if (response.ok) {
        const contentType = response.headers.get('content-type');
        try {
            if (contentType && contentType.includes('application/json')) {
                result = yield response.json();
            }
        }
        catch (e) {
            console.error(`Failed to parse JSON from ${url}:`, e);
        }
    }
    return result;
});
const applyOverrides = (config) => __awaiter(void 0, void 0, void 0, function* () {
    const override = yield fetchJson(CONFIG_OVERRIDE_URL);
    if (override) {
        return fillInObject(config, override);
    }
    return config;
});
const userPortalTranslator = (userportalConfig) => {
    var _a, _b, _c, _d;
    const result = Object.assign({}, userportalConfig);
    result.blocksync_segmentWriteKey = (_b = (_a = userportalConfig.segment) === null || _a === void 0 ? void 0 : _a.writeKey) !== null && _b !== void 0 ? _b : '';
    result.central_segmentWriteKey = (_d = (_c = userportalConfig.segment) === null || _c === void 0 ? void 0 : _c.writeKey) !== null && _d !== void 0 ? _d : '';
    result.environment = userportalConfig.sentryEnvironment;
    return result;
};
export const ProvideConfig = ({ children, useUserPortalConfigJson, poll = false, customConfig = {}, }) => {
    const [loaded, setLoaded] = useState(false);
    const getConfigData = () => __awaiter(void 0, void 0, void 0, function* () {
        if (process.env.NODE_ENV !== 'production') {
            return devConfig;
        }
        const configUrl = useUserPortalConfigJson ? USER_PORTAL_CONFIG_URL : CONFIG_URL;
        const config = yield fetchJson(configUrl);
        if (!config) {
            return null;
        }
        if (useUserPortalConfigJson) {
            return userPortalTranslator(config);
        }
        if ((config === null || config === void 0 ? void 0 : config.environment) === 'development') {
            return applyOverrides(config);
        }
        return config;
    });
    const loadConfig = () => __awaiter(void 0, void 0, void 0, function* () {
        const config = Object.assign(Object.assign({}, (yield getConfigData())), customConfig);
        if (config) {
            sessionStorage.setItem(CONFIG, JSON.stringify(config));
        }
        else {
            console.warn('Site configuration not present');
        }
    });
    const reloadConfigPeriodically = () => __awaiter(void 0, void 0, void 0, function* () {
        setTimeout(() => {
            loadConfig();
            reloadConfigPeriodically();
        }, CONFIG_REFETCH_INTERVAL);
    });
    useEffect(() => {
        loadConfig().then(() => setLoaded(true));
        if (poll) {
            reloadConfigPeriodically();
        }
    }, []);
    return loaded ? children : null;
};
export const getConfig = () => JSON.parse(sessionStorage.getItem(CONFIG) || '{}');
export const isConfigSet = () => {
    const config = sessionStorage.getItem(CONFIG);
    if (config && config !== '{}') {
        return true;
    }
    return false;
};
//# sourceMappingURL=AppConfig.js.map